import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../buttons/Button';
import { Pick } from '../../../../types';
import { calculateAmountToPick } from '../../../../utils';

import styles from './CommercialSkipFlow.css';

type Props = {
  picks: Pick[];
  onComplete: () => void;
};

const EPSkippedItemReportView = ({ picks, onComplete }: Props): ReactElement => {
  const { t } = useTranslation();
  const translationRoot = 'COMMERCIAL_SKIP_FLOW';

  const skippedPicks = picks.filter(pick => pick.isSkipped);

  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <h3 className={styles.headerText}>{t(`${translationRoot}.SKIPPED_ITEMS`)}</h3>
        <article className={styles.article}>
          <p className={styles.p}>{t(`${translationRoot}.PICKED_ITEMS_TRANSFERRED`)}</p>
        </article>
        <article className={styles.article}>
          <p className={styles.p}>{t(`${translationRoot}.CHECK_PRINTER_META`)}</p>
        </article>
        <ul className={styles.list}>
          <li className={styles.listHeader}>
            <h5 className={styles.partLabel}>{t('ACTIVE_PICK_TOUR.DETAILS_VIEW.PART_NUMBER')}</h5>
            <h5 className={styles.qtyLabel}>{t('ACTIVE_PICK_TOUR.PICK_TOUR_FOOTER.QTY')}</h5>
          </li>
          {skippedPicks.map(pick => (
            <li key={`${pick.orderID}-${pick.lineNumber}`} className={styles.listItem}>
              <span className={styles.part}>{pick.partNumber}</span>
              <span className={styles.qty}>{calculateAmountToPick(pick) - pick.pickedQuantity}</span>
            </li>
          ))}
        </ul>
      </header>
      <footer className={styles.outsideBuyFooter}>
        <Button className={styles.fullButton} color="primary" onClick={onComplete}>
          {t(`${translationRoot}.BUTTONS.CONTINUE`)}
        </Button>
      </footer>
    </section>
  );
};

export default EPSkippedItemReportView;
